export default __webpack_public_path__ + "static/media/14.0cbc2fe9.jpg";